import { colors } from 'styles/colors';

type FilePlus1IconProps = {
  color?: string;
  size?: number;
}

export const FilePlus1Icon = ({ color = colors.icon['primary-base'], size }: FilePlus1IconProps): JSX.Element => (
  <svg width={size ?? '14'} height={size ?? '15'} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5619_10937)">
      <path d="M11.6673 6.625V4.46667C11.6673 3.48658 11.6673 2.99653 11.4766 2.62218C11.3088 2.2929 11.0411 2.02518 10.7118 1.85741C10.3375 1.66667 9.84741 1.66667 8.86732 1.66667H5.13398C4.15389 1.66667 3.66385 1.66667 3.2895 1.85741C2.96022 2.02518 2.6925 2.2929 2.52472 2.62218C2.33398 2.99653 2.33398 3.48658 2.33398 4.46667V10.5333C2.33398 11.5134 2.33398 12.0035 2.52472 12.3778C2.6925 12.7071 2.96022 12.9748 3.2895 13.1426C3.66385 13.3333 4.15389 13.3333 5.13398 13.3333H7.00065M10.5007 12.75V9.25M8.75065 11H12.2507" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_5619_10937">
        <rect width="14" height="14" fill={color} transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
